export class FinancialBudget {
    id: number;
    month: string;
    year: string;
    value: number;
}
